import React, { useState, useEffect } from 'react';
import { Box, Typography, Chip, IconButton } from '@mui/material';
import useSignalingStore from 'views/signalingStore';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
// Note: useFetchUser is now handled by WebSocketManager

// Note: WebSocket URLs are now managed by WebSocketManager component

// Connection state constants
const CONNECTION_STATES = {
  CONNECTED: 'Connected',
  CONNECTING: 'Connecting',
  DISCONNECTED: 'Disconnected',
  RECONNECTING: 'Reconnecting',
  ERROR: 'Error'
};

const WebSocketStatus = () => {
  const {
    signalingServer,
    signalingServer2,
    signalingServer3
  } = useSignalingStore();

  // Note: User ID is now managed by WebSocketManager

  const [status1, setStatus1] = useState(CONNECTION_STATES.DISCONNECTED);
  const [status2, setStatus2] = useState(CONNECTION_STATES.DISCONNECTED);
  const [status3, setStatus3] = useState(CONNECTION_STATES.DISCONNECTED);
  const [visible, setVisible] = useState(false);

  // Note: WebSocket creation and reconnection is now handled by WebSocketManager
  // This component only monitors the connection status from the store

  // Note: Activity tracking and reconnection logic is now handled by WebSocketManager

  // Monitor notification WebSocket
  useEffect(() => {
    if (signalingServer) {
      if (signalingServer.readyState === WebSocket.OPEN) {
        setStatus1(CONNECTION_STATES.CONNECTED);
      } else if (signalingServer.readyState === WebSocket.CONNECTING) {
        setStatus1(CONNECTION_STATES.CONNECTING);
      } else {
        setStatus1(CONNECTION_STATES.DISCONNECTED);
      }
      

      const handleOpen = () => {
        console.log('Notification socket connected');
        setStatus1(CONNECTION_STATES.CONNECTED);
      };

      const handleClose = (event) => {
        console.log(`Notification socket disconnected. Code: ${event.code}, Reason: ${event.reason}`);
        setStatus1(CONNECTION_STATES.DISCONNECTED);
      };

      const handleError = (error) => {
        console.error('Notification socket error:', error);
        setStatus1(CONNECTION_STATES.ERROR);
      };

      signalingServer.addEventListener('open', handleOpen);
      signalingServer.addEventListener('close', handleClose);
      signalingServer.addEventListener('error', handleError);

      return () => {
        signalingServer.removeEventListener('open', handleOpen);
        signalingServer.removeEventListener('close', handleClose);
        signalingServer.removeEventListener('error', handleError);
      };
    }
  }, [signalingServer]);

  // Monitor message notification WebSocket
  useEffect(() => {
    if (signalingServer2) {
      if (signalingServer2.readyState === WebSocket.OPEN) {
        setStatus2(CONNECTION_STATES.CONNECTED);
      } else if (signalingServer2.readyState === WebSocket.CONNECTING) {
        setStatus2(CONNECTION_STATES.CONNECTING);
      } else {
        setStatus2(CONNECTION_STATES.DISCONNECTED);
      }

      const handleOpen = () => {
        console.log('Messages socket connected');
        setStatus2(CONNECTION_STATES.CONNECTED);
      };

      const handleClose = (event) => {
        console.log(`Messages socket disconnected. Code: ${event.code}, Reason: ${event.reason}`);
        setStatus2(CONNECTION_STATES.DISCONNECTED);
      };

      const handleError = (error) => {
        console.error('Messages socket error:', error);
        setStatus2(CONNECTION_STATES.ERROR);
      };

      signalingServer2.addEventListener('open', handleOpen);
      signalingServer2.addEventListener('close', handleClose);
      signalingServer2.addEventListener('error', handleError);

      return () => {
        signalingServer2.removeEventListener('open', handleOpen);
        signalingServer2.removeEventListener('close', handleClose);
        signalingServer2.removeEventListener('error', handleError);
      };
    }
  }, [signalingServer2]);

  // Monitor ring WebSocket
  useEffect(() => {
    if (signalingServer3) {
      if (signalingServer3.readyState === WebSocket.OPEN) {
        setStatus3(CONNECTION_STATES.CONNECTED);
      } else if (signalingServer3.readyState === WebSocket.CONNECTING) {
        setStatus3(CONNECTION_STATES.CONNECTING);
      } else {
        setStatus3(CONNECTION_STATES.DISCONNECTED);
      }

      const handleOpen = () => {
        console.log('Calls socket connected');
        setStatus3(CONNECTION_STATES.CONNECTED);
      };

      const handleClose = (event) => {
        console.log(`Calls socket disconnected. Code: ${event.code}, Reason: ${event.reason}`);
        setStatus3(CONNECTION_STATES.DISCONNECTED);
      };

      const handleError = (error) => {
        console.error('Calls socket error:', error);
        setStatus3(CONNECTION_STATES.ERROR);
      };

      signalingServer3.addEventListener('open', handleOpen);
      signalingServer3.addEventListener('close', handleClose);
      signalingServer3.addEventListener('error', handleError);

      return () => {
        signalingServer3.removeEventListener('open', handleOpen);
        signalingServer3.removeEventListener('close', handleClose);
        signalingServer3.removeEventListener('error', handleError);
      };
    }
  }, [signalingServer3]);

  // Note: Initial connection setup is now handled by WebSocketManager

  const toggleVisibility = () => {
    setVisible(!visible);
  };

  return (
    <>
      {/* Always show the toggle button */}
      {/* <IconButton 
        onClick={toggleVisibility} 
        sx={{ 
          position: 'fixed', 
          bottom: 20, 
          right: 20, 
          zIndex: 9999,
          backgroundColor: 'rgba(255,255,255,0.8)',
          boxShadow: 1,
          '&:hover': {
            backgroundColor: 'rgba(255,255,255,0.9)'
          }
        }}
      >
        {visible ? <VisibilityOffIcon /> : <VisibilityIcon />}
      </IconButton> */}

      {/* Show status info only when visible */}
      {visible && (
        <Box 
          sx={{ 
            position: 'fixed', 
            bottom: 70, 
            right: 20, 
            zIndex: 9999, 
            backgroundColor: 'rgba(255,255,255,0.8)', 
            p: 1,
            borderRadius: 1,
            boxShadow: 1,
            maxWidth: '300px'
          }}
        >
          <Typography variant="caption" sx={{ fontWeight: 'bold' }}>WebSocket Status</Typography>
          <Box sx={{ display: 'flex', gap: 1, flexDirection: 'column', mt: 0.5 }}>
            <Chip 
              size="small" 
              label={`Notifications: ${status1}`}
              color={status1 === CONNECTION_STATES.CONNECTED ? 'success' : 
                     status1 === CONNECTION_STATES.CONNECTING || status1 === CONNECTION_STATES.RECONNECTING ? 'warning' : 
                     'error'}
            />
            <Chip 
              size="small" 
              label={`Messages: ${status2}`}
              color={status2 === CONNECTION_STATES.CONNECTED ? 'success' : 
                     status2 === CONNECTION_STATES.CONNECTING || status2 === CONNECTION_STATES.RECONNECTING ? 'warning' : 
                     'error'}
            />
            <Chip 
              size="small" 
              label={`Calls: ${status3}`}
              color={status3 === CONNECTION_STATES.CONNECTED ? 'success' : 
                     status3 === CONNECTION_STATES.CONNECTING || status3 === CONNECTION_STATES.RECONNECTING ? 'warning' : 
                     'error'}
            />
          </Box>
        </Box>
      )}
    </>
  );
};

export default WebSocketStatus; 